import { Component, OnInit, ViewChild } from '@angular/core';
import { UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { SharedService } from '@shared/services/shared.service';
import { EditBusinessComponent } from 'app/components/business/editBusiness/editBusiness.component';
import { IBusinessView } from 'app/models/business/business';
import { IReportSelectItems, ISelectItems } from 'app/models/shared/shared';
import { AdminService } from 'app/services/admin/admin.service';
import { ReportsService } from 'app/services/reports/reports.service';

@Component({
  selector: 'app-mergeBusiness',
  templateUrl: './mergeBusiness.component.html',
  styleUrls: ['./mergeBusiness.component.scss']
})

export class MergeBusinessComponent implements OnInit {

  showNext: boolean = false;
  showSuccess: boolean = false;
  searchList: IBusinessView[] = [];
  resultsCount: number = 0;
  filter: string = '';
  businessId: string = '';
  currentBusiness: IBusinessView;
  complaintList: ISelectItems[] = [];
  selectActionList: ISelectItems[] = [];
  selectStatusList: IReportSelectItems[] = [];
  nonActionableList: ISelectItems[] = [];
  mergeBusiness: IBusinessView;
  selected: string = '';
  mergeText: string = '';

  displayedColumns: string[] = ['selected', 'id', 'businessName', 'active', 'exempt', 'businessAddress1',
    'businessCity', 'businessZip', 'countyName', 'totalComplaints'];
  dataSource = new MatTableDataSource<IBusinessView>(this.searchList);

  @ViewChild('TablePaginator') paginator: MatPaginator;
  @ViewChild('TableSort') sort: MatSort;

  constructor(public adminService: AdminService,
    public sharedService: SharedService,
    private modalService: MatDialog,
    public reportService: ReportsService) { }

  form = new UntypedFormGroup({
    searchText: new UntypedFormControl('', [Validators.maxLength(50), Validators.required]),
  });

  ngOnInit(): void {
    this.form.controls['searchText'].setValue(this.adminService.businessAdminSearch);
    this.currentBusiness = this.adminService.currentBusiness;
    this.searchList = this.adminService.businessList.filter(x => x.id != this.currentBusiness.id);
    if (this.searchList.length > 0) {
      this.dataSource.data = this.searchList;
      this.dataSource.paginator = this.paginator;
      this.dataSource.sort = this.sort;
    }
    this.showNext = false;
    this.showSuccess = false;
    this.mergeText = ' ' + this.currentBusiness.businessName + ' ';
  }

  getSearchBusinessData() {
    this.adminService.businessAdminSearch = String(this.form.controls['searchText'].value);
    let searchText = String(this.form.controls['searchText'].value);
    if (searchText != null && searchText != '' && searchText.length < 3) {
      this.sharedService.toastr.error("Search text must be at least 3 characters");
      return;
    }
    this.adminService.businessAdminSearch = String(this.form.controls['searchText'].value);
    this.adminService.getBusinessAdminData(this.adminService.businessAdminSearch).subscribe({
      next: response => {
        this.searchList = response.filter(x => x.id != this.currentBusiness.id);
        this.dataSource.data = this.searchList;
        this.dataSource.paginator = this.paginator;
        this.dataSource.sort = this.sort;
        if (response != null) {
          this.resultsCount = this.searchList.length;
        }
        this.selected = '';
      },
      error: e => {
        this.sharedService.toastr.error("Could not get business admin data");
      },
    });
  }

  rowClick(row: IBusinessView) {
    this.businessId = row.id == null ? '0' : row.id.toString();
    this.adminService.currentBusiness = row;

    let config = new MatDialogConfig<any>();
    config.autoFocus = true;
    config.disableClose = false;
    config.minWidth = 600;
    config.data = {
      newBusiness: false
    };
    const dialogRef = this.modalService.open(EditBusinessComponent, config);
    dialogRef.afterClosed().subscribe(
      data => {
        if (data == 'saved') {
          this.getSearchBusinessData();
        }
      },
      error => console.log('error: ', error),
      () => { }
    );
  }

  radioChange(event: string) {
    this.selected = event;
  }

  filterTable(event: Event) {
    this.dataSource.filter = (event.target as HTMLInputElement).value.trim().toLocaleLowerCase();
    this.filter = this.dataSource.filter;
  }

  cancel() {
    // this.showNext = false;    
    this.sharedService.doRedirect('admin/businessAdmin');
  }

  next() {
    if (this.selected != '') {
      this.showNext = true;
      this.mergeBusiness = this.searchList.find(x => x.id == +this.selected);
    }
  }

  back() {
    // this.sharedService.doRedirect('admin/businessAdmin');
    this.showNext = false;
  }

  merge() {
    if (this.selected != '') {
      this.mergeBusiness = this.searchList.find(x => x.id == +this.selected);
    }
  }

  saveMerge() {
    if (this.selected != null && this.selected != '') {
      this.adminService.saveMerge(this.currentBusiness.id, this.mergeBusiness.id).subscribe({
        next: response => {
          this.selected = '';
          this.showSuccess = true;
        },
        error: e => {
          this.showSuccess = false;
          this.sharedService.toastr.error("Could not merge businesses. Please contact support.");
        },
      });
    }
    else {
      this.sharedService.toastr.error("Please select a business to merge");
    }
  }

}

